module.exports = __webpack_public_path__ + "static/media/tt.cac53785.svg";